import { render, staticRenderFns } from "./contest.vue?vue&type=template&id=ef04bb42&"
import script from "./contest.vue?vue&type=script&lang=js&"
export * from "./contest.vue?vue&type=script&lang=js&"
import style0 from "./contest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports